"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ProcessSetter = exports.DownloadListItem = exports.DownloadImageMap = exports.CopyUrl = void 0;
var CardStyles = _interopRequireWildcard(require("./DownloadCardStyles"));
var DownloadCardMethods = _interopRequireWildcard(require("./DownloadCard"));
var _ImportedContentFragment = _interopRequireDefault(require("../ContentFragments/ImportedContentFragment"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _function = require("../../utils/type-checks/function");
var _object = require("../../utils/type-checks/object");
var _string = require("../../utils/type-checks/string");
var _styles = require("@mui/material/styles");
var _uuid = require("uuid");
var _material = require("@mui/material");
var _react = _interopRequireWildcard(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const merge = require("deepmerge"),
  DownloadImageMap = exports.DownloadImageMap = [{
    type: "doc",
    path: `${process.env.PUBLIC_URL}/general/images/toolkit/icons/word-icon.svg`,
    alt: "File Format: Microsoft Word Document"
  }, {
    type: "jpg",
    path: `${process.env.PUBLIC_URL}/general/images/toolkit/icons/jpg-icon.svg`,
    alt: "File Format: JPEG Image File"
  }, {
    type: "newwindow",
    path: `${process.env.PUBLIC_URL}/general/images/toolkit/icons/new-window-icon.svg`,
    alt: "Result opens in a new window"
  }, {
    type: "pdf",
    path: `${process.env.PUBLIC_URL}/general/images/toolkit/icons/pdf-icon.svg`,
    alt: "File Format: PDF File"
  }, {
    type: "youtube",
    path: `${process.env.PUBLIC_URL}/general/images/toolkit/icons/youtube-icon.svg`,
    alt: "YouTube Link - will open in new window"
  }, {
    type: "ppt",
    path: `${process.env.PUBLIC_URL}/general/images/toolkit/icons/ppt-icon.svg`,
    alt: "File Format: Microsoft PowerPoint"
  }, {
    type: "xls",
    path: `${process.env.PUBLIC_URL}/general/images/toolkit/icons/excel-outline-icon.svg`,
    alt: "File Format: Microsoft Excel"
  }],
  CopyUrl = (e, simulateFallback) => {
    let event = e,
      result = "Copy",
      copyText;
    if (event && event.target && (0, _string.isStringOfLength)(event.target.value) && (0, _function.isFunction)(event.preventDefault)) {
      event.preventDefault();
      const {
        value
      } = event.target;
      try {
        if ((0, _object.isObject)(navigator) && (0, _object.isObject)(navigator.clipboard) && (0, _function.isFunction)(navigator.clipboard.writeText) && simulateFallback !== true) {
          // Copies button value to clipboard
          navigator.clipboard.writeText(value);
          result = "Copied";
        } else if ((0, _object.isObject)(document) && (0, _function.isFunction)(document.execCommand) || simulateFallback === true) {
          copyText = document.createElement("textarea");
          copyText.style.positon = "absolute";
          copyText.style.height = "1px";
          copyText.style.left = "-9999px";
          copyText.style.opacity = "0";
          copyText.style.top = "-9999px";
          copyText.style.width = "1px";
          copyText.value = value;
          document.body.appendChild(copyText);
          copyText.select();
          document.execCommand("copy");
          result = "Copied";
          document.body.removeChild(copyText);
        } else {
          throw new Error();
        }
      } catch (e) {
        result = "Not Copied";
      }
    }
    return result;
  },
  ProcessSetter = (value, setter) => {
    let result = null;
    if ((0, _string.isStringOfLength)(value) && (0, _function.isFunction)(setter)) {
      setter(value);
      result = value;
    }
    return result;
  },
  DownloadListItem = props => {
    const {
        caption,
        children,
        delay = 2000,
        imageMap = DownloadImageMap,
        isNewWindow,
        name,
        path,
        simulateFallback,
        testId,
        type
      } = props,
      isDownload = isNewWindow !== true && type !== "newwindow" && type !== "youtube",
      target = isNewWindow !== false ? "_blank" : "_self",
      hasClipboard = (0, _object.isObject)(navigator) && (0, _object.isObject)(navigator.clipboard) && (0, _function.isFunction)(navigator.clipboard.writeText) || (0, _object.isObject)(document) && (0, _function.isFunction)(document.execCommand),
      imageData = imageMap.filter(data => data.type === type),
      [copyText, setCopyText] = (0, _react.useState)("Copy"),
      concatPath = new RegExp("^[a-z]+:", "i").test(path) === false ? path.indexOf("/") === 0 ? window.location.origin + path : window.location.origin + "/" + path : path,
      handleClick = e => {
        DownloadCardMethods.ProcessSetter(DownloadCardMethods.CopyUrl(e, simulateFallback), setCopyText);
        setTimeout(() => {
          DownloadCardMethods.ProcessSetter("Copy", setCopyText);
        }, delay);
      };
    return /*#__PURE__*/_react.default.createElement(_material.ListItem, {
      className: "download-card__list-item",
      "data-testid": testId
    }, /*#__PURE__*/_react.default.createElement(_material.Box, {
      className: "download-card__content"
    }, children ? /*#__PURE__*/_react.default.createElement(_react.Fragment, null, children) : /*#__PURE__*/_react.default.createElement(_react.Fragment, null, isDownload && /*#__PURE__*/_react.default.createElement("a", {
      className: "download-card__link",
      download: true,
      href: path,
      target: target
    }, name), !isDownload && /*#__PURE__*/_react.default.createElement("a", {
      className: "download-card__link",
      href: path,
      target: target
    }, name), (0, _string.isStringOfLength)(caption) && /*#__PURE__*/_react.default.createElement(_material.Box, {
      className: "download-card__content-caption",
      component: "span",
      "data-testid": testId ? `${testId}__caption` : undefined
    }, caption))), /*#__PURE__*/_react.default.createElement(_material.Box, {
      className: "download-card__actions"
    }, imageData.length > 0 && /*#__PURE__*/_react.default.createElement(_material.CardMedia, {
      alt: imageData[0].alt,
      className: "download-card__image-type",
      component: "img",
      height: "23",
      src: imageData[0].path
    }), hasClipboard && /*#__PURE__*/_react.default.createElement(_material.Button, {
      className: "download-card__copy-button",
      component: "button",
      onClick: handleClick,
      title: "Copy the file path to your clipboard",
      value: concatPath,
      variant: "contained"
    }, copyText)));
  };

/**
 * Card to with list of downloadable documents
 *
 * @visibleName Download Card
 * @author [Jeff Stevens](mailto:jeffrey.stevens@pheaa.org)
*/
exports.DownloadListItem = DownloadListItem;
exports.ProcessSetter = ProcessSetter;
exports.CopyUrl = CopyUrl;
const DownloadCard = props => {
  const {
      className,
      customComponentMap = {},
      customTheme = {},
      description,
      descriptionTag = "p",
      fileList,
      fragmentFileList,
      initialTheme = {},
      simulateFallback = false,
      styles = {},
      tag = "p",
      testId,
      title,
      variant = "default",
      ...rest
    } = props,
    ComponentMap = merge({
      DownloadListItem: DownloadListItem,
      ImportedContentFragment: _ImportedContentFragment.default
    }, customComponentMap),
    theme = merge.all([initialTheme, (0, _styles.useTheme)(), customTheme]),
    uuidSeed = (0, _react.useRef)((0, _uuid.v4)()),
    cardClasses = (0, _classnames.default)({
      "download-card": true,
      [`${className}`]: className,
      "download-card--isPressRelease": variant === "press-release"
    }),
    componentStyles = merge(CardStyles.DownloadCardStyles(theme, variant), styles);
  return /*#__PURE__*/_react.default.createElement(_material.Card, {
    className: cardClasses,
    component: "article",
    "data-testid": testId,
    sx: componentStyles
  }, title && /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "download-card__title",
    component: tag
  }, title), description && /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "download-card__description",
    component: descriptionTag
  }, description), /*#__PURE__*/_react.default.createElement(_material.List, {
    className: "download-card__list"
  }, fileList && fileList.map((fileItem, i) => /*#__PURE__*/_react.default.createElement(ComponentMap.DownloadListItem, _extends({
    key: `download__item__${uuidSeed.current}__${i}`
  }, fileItem, {
    simulateFallback: simulateFallback
  }, rest))), fragmentFileList && /*#__PURE__*/_react.default.createElement(ComponentMap.ImportedContentFragment, _extends({
    component: "downloadList",
    id: fragmentFileList,
    simulateFallback: simulateFallback
  }, rest))));
};

// Define propTypes;
DownloadListItem.propTypes = {
  caption: _propTypes.default.string,
  children: props => {
    if (!props.name && !props.children) {
      console.error("Custom PropTypes Check: Either Name or Children are required for this component");
    }
  },
  delay: _propTypes.default.number,
  imageMap: _propTypes.default.arrayOf(_propTypes.default.shape({
    type: _propTypes.default.string.isRequired,
    path: _propTypes.default.string.isRequired,
    alt: _propTypes.default.string.isRequired
  })),
  isNewWindow: _propTypes.default.bool,
  name: props => {
    if (!props.name && !props.children) {
      console.error("Custom PropTypes Check: Either Name or Children are required for this component");
    } else if (!props.children && (typeof props.name !== "string" || props.name.trim().length < 1)) {
      console.error("Custom PropTypes Check: Name Property must be a String");
    }
  },
  path: _propTypes.default.string.isRequired,
  simulateFallback: _propTypes.default.bool,
  testId: _propTypes.default.string,
  type: _propTypes.default.string.isRequired
};
DownloadCard.propTypes = {
  /** Custom class(es) */
  className: _propTypes.default.string,
  /** Optional custom component map for passing instance components */
  customComponentMap: _propTypes.default.objectOf(_propTypes.default.elementType),
  /** Theme injection object (Default Value: {}) */
  customTheme: _propTypes.default.object,
  /** @ignore */
  simulateFallback: _propTypes.default.bool,
  /** Custom style overrides (Default Value: {}) */
  styles: _propTypes.default.object,
  /** Description of download file */
  description: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node, _propTypes.default.element]),
  /** HTML Tag for description block (Default Value: "p") */
  descriptionTag: _propTypes.default.string,
  /** List of Downloadable Files */
  fileList: _propTypes.default.arrayOf(_propTypes.default.shape({
    ...DownloadListItem.propTypes
  })),
  /** Fragment Id */
  fragmentFileList: _propTypes.default.string,
  /** Object theme stub for custom components */
  initialTheme: _propTypes.default.object,
  /** Header title element tag */
  tag: _propTypes.default.oneOf(["h1", "h2", "h3", "h4", "h5", "h6", "p"]),
  /** @ignore */
  testId: _propTypes.default.string,
  /** Header title */
  title: _propTypes.default.string,
  /** Card design variant */
  variant: _propTypes.default.oneOf(["default", "press-release"])
};

// Export component as default;
var _default = exports.default = DownloadCard;